module.exports = __webpack_public_path__ + "img/hutaomu5.7618b74c.jpg";